import React from "react";
import {confirmAlert} from "react-confirm-alert";
import Alert from "../Alert";

const InvalidDataConfirm = () => {
    let msg = "These tasks were updated by other users, Reloading.....";
    confirmAlert({
        customUI: ({onClose}) => {
            return (
                <Alert msg={msg} onClose={onClose} style ={{width:"50%"}}/>

            );
        }
    });
};

export  default InvalidDataConfirm;